export default __webpack_public_path__ + "static/media/Head_4_Ear_2_C1.899b17f3.svg";